import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=3c1f1c45&scoped=true&"
import script from "./AppBase.vue?vue&type=script&lang=js&"
export * from "./AppBase.vue?vue&type=script&lang=js&"
import style0 from "./AppBase.vue?vue&type=style&index=0&id=3c1f1c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f1c45",
  null
  
)

export default component.exports